import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from '../cart/services/store';
import RegimenFinder from './components/regimen_finder/RegimenFinder';

document.addEventListener('DOMContentLoaded', () => {
  window.store = window.store || store;
  const element = document.getElementById('react-regimen-finder');

  createRoot(
    element,
  ).render(
    <Provider store={window.store}>
      <RegimenFinder />
    </Provider>,
  );

  const StickyCategories = React.lazy(() => import('../homepage/components/sticky_categories/StickyCategories'));
  createRoot(
    document.getElementById('react-sticky-categories'),
  ).render(
    <Suspense fallback="">
      <Provider store={window.store}>
        <StickyCategories />
      </Provider>
    </Suspense>,
  );
});
